import React from 'react';
import { Heart } from 'lucide-react';
import BackToHomeButton from '../components/BackToHomeButton';

export default function Donations() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-3">
          <Heart className="h-8 w-8 text-brand-teal" />
          <h1 className="text-3xl font-bold text-brand-teal">Doações</h1>
        </div>
        <BackToHomeButton />
      </div>

      <div className="grid gap-8">
        <section className="bg-white p-8 rounded-xl shadow-sm">
          <h2 className="text-2xl font-semibold text-brand-teal mb-4">Contribua com a Obra</h2>
          <p className="text-gray-600 mb-6">
            Sua contribuição é fundamental para mantermos e expandirmos o trabalho
            da igreja em Brasília e além. Todas as doações são utilizadas com
            transparência e responsabilidade.
          </p>

          <div className="grid gap-6 md:grid-cols-2">
            <div className="p-6 bg-brand-light rounded-lg">
              <h3 className="text-xl font-semibold text-brand-teal mb-4">Transferência Bancária</h3>
              <div className="space-y-2 text-gray-600">
                <p><strong>Banco:</strong> XXX</p>
                <p><strong>Agência:</strong> XXXX</p>
                <p><strong>Conta:</strong> XXXXX-X</p>
                <p><strong>CNPJ:</strong> XX.XXX.XXX/0001-XX</p>
              </div>
            </div>

            <div className="p-6 bg-brand-light rounded-lg">
              <h3 className="text-xl font-semibold text-brand-teal mb-4">PIX</h3>
              <div className="space-y-2 text-gray-600">
                <p><strong>Chave:</strong> CNPJ XX.XXX.XXX/0001-XX</p>
                <button className="mt-4 bg-brand-teal text-white px-4 py-2 rounded-lg hover:bg-brand-teal/90 transition-colors">
                  Copiar Chave PIX
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-white p-8 rounded-xl shadow-sm">
          <h2 className="text-2xl font-semibold text-brand-teal mb-4">Prestação de Contas</h2>
          <p className="text-gray-600">
            Mantemos o compromisso com a transparência na gestão dos recursos.
            Mensalmente, apresentamos à igreja um relatório detalhado da utilização
            dos recursos recebidos.
          </p>
        </section>
      </div>
    </div>
  );
}